import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useIntl, defineMessages } from "react-intl";
import Link from "theme/components/atoms/Typography/Link";
import Logo from "theme/components/atoms/Logo";
import Socials from "./Socials/Socials";
import FootersLinksList from "./FootersLinksList/FootersLinksList";
import classnames from "classnames";

const messages = defineMessages({
  informations: {
    id: "layout.Footer.BottomBar.Informations",
    defaultMessage: "Informations",
  },
  robertet: {
    id: "layout.Footer.BottomBar.Robertet",
    defaultMessage: "Robertet",
  },
  officialWebsite: {
    id: "layout.Footer.BottomBar.OfficialWebsite",
    defaultMessage: "Official Website",
  },
});

const BottomBar = (props) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(true);
  let contactFooterHtml = "";
  if (props.footerContact) {
    contactFooterHtml = props.footerContact.content;
  }

  let informationFooterHtml = "";
  if (props.footerInformation) {
    informationFooterHtml = props.footerInformation.content;
  }

  useEffect(() => {
    if (props.footerContact || props.footerInformation) {
      setIsLoading(false);
    }
  }, [props.footerContact, props.footerInformation]);

  return (
    <div className="bottombar container">
      <div className="bottombar__left">
        <div
          className={classnames(
            "bottombar__links-col bottombar__links-col-first",
            { "bottombar__links-col-first--loading": isLoading }
          )}
        >
          <div className="bottombar__title">
            <Logo appearance="white" ariaHidden={true} />
            <span className="sr-only">
              {intl.formatMessage(messages.robertet)}
            </span>
          </div>
          <FootersLinksList links={contactFooterHtml} />
          <Socials
            facebookLink={props.facebookLink}
            instagramLink={props.instagramLink}
            viadeoLink={props.viadeoLink}
            linkedinLink={props.linkedinLink}
          />
        </div>
        <div
          className={classnames(
            "bottombar__links-col bottombar__links-col-second",
            { "bottombar__links-col-second--loading": isLoading }
          )}
        >
          <FootersLinksList
            title={intl.formatMessage(messages.informations)}
            links={informationFooterHtml}
          />
        </div>
      </div>
      <div className="bottombar__logo">
        <Link
          to="https://www.robertet.com/"
          external
          aria-label={intl.formatMessage(messages.officialWebsite)}
        >
          <Logo appearance="full" ariaHidden={true} alt="" lazyLoad={true} />
        </Link>
      </div>
    </div>
  );
};

BottomBar.propTypes = {
  categories: PropTypes.object,
  accountDetails: PropTypes.array,
  contactList: PropTypes.array,
  footerContact: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  footerInformation: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  facebookLink: PropTypes.string,
  instagramLink: PropTypes.string,
  viadeoLink: PropTypes.string,
  linkedinLink: PropTypes.string,
  footerLogo: PropTypes.string,
};

export default BottomBar;
